import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import {
  LANDING_BREAKPOINT,
  LANDING_BREAKPOINT_VALUE,
} from '@utils/theme/breakPoint';

export const Container = styled.div`
  width: ${LANDING_BREAKPOINT};

  @media (max-width: ${LANDING_BREAKPOINT_VALUE - 1}px) {
    width: 100%;
  }
`;

export const HeaderContainer = styled.div`
  padding: 0 0 16px;
  @media (max-width: ${LANDING_BREAKPOINT_VALUE - 1}px) {
    padding-bottom: 16px;
  }
`;
export const Wrapper = styled.div`
  justify-content: space-between;
  display: flex;
`;
export const Header = styled.h2<{
  fontsize?: number;
}>`
  font-size: ${(p) => `${p.fontsize ? p.fontsize : '24'}px`};
  color: ${({ theme }) => theme.palette.coral};
  font-weight: 900;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: ${(p) => `${p.fontsize ? p.fontsize : '30'}px`};
  }
`;

export const SmBannerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 40px;
  padding-top: 16px;
  @media (max-width: ${LANDING_BREAKPOINT_VALUE - 1}px) {
    padding-bottom: 30px;
  }
`;

export const ItemWrapper = styled.div`
  max-width: 1240px;
  margin-bottom: 12px;
  .swiper-slide {
    margin-right: 13.3px !important;
    max-width: 300px !important;
    width: 100% !important;
  }
`;
export const ContentWrapper = styled.div`
  margin-top: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  padding: 8px;
  border-radius: 8px;
  gap: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 12px;
  }
`;
export const StyledSwiper = styled(Swiper)`
  width: 100%;
`;
